import { SWED_BANK_INTEGRATION_STATUS } from 'redux/reducers/swedBank/constants';
import { ISwedBankIntegrationItem, SwedBankIntegrationStatus } from 'redux/reducers/swedBank/types';
import { DATES, DATES_ID } from 'services/constants/dates-constants';
import { TypeOfDialog } from './types';
import { ETableStructureAlign, ETableStructureType } from '../../ui/EasTable/types';

export const swedBankStructure = [
	{
		name: 'Bank Reference ID',
		selector: 'bankRefenceNumber',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		filter: [
			['SEB', 'SEB'],
			['Swedbank', 'Swedbank'],
			['Luminor', 'Luminor'],
			['Citadele', 'Citadele'],
			['DNB', 'DNB'],
			['Nordea', 'Nordea'],
			['Revolut', 'Revolut'],
			['Nordex', 'Nordex'],
			['S-Panki', 'S-Panki'],
			['Aland', 'Aland'],
			['Other', 'Other'],
		],
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'IOSS Number',
		selector: 'iossReimbursementNumber',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.IOSS_NUMBER,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Doc Num',
		selector: 'internalInvoiceId',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Client Name',
		selector: 'debitorName',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,

		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Client Country',
		selector: 'debitorCountry',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Payment Date',
		selector: 'paymentDate',
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],

		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Client IBAN',
		selector: 'debitorBankAccount',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Processed Date',
		selector: 'createdAt',
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],

		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Reg Num',
		selector: 'endToEndId',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Payment Description',
		selector: 'paymentInformation',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,

		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Amount',
		selector: 'amount',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		currency: (item: ISwedBankIntegrationItem) => item.currency ?? '---',
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'EAS Invoice',
		selector: 'easInvoiceNumber',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.INVOICE_NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Status',
		selector: 'status',
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			[
				SwedBankIntegrationStatus.PROCESSED_STATUS,
				SWED_BANK_INTEGRATION_STATUS(SwedBankIntegrationStatus.PROCESSED_STATUS),
			],
			[
				SwedBankIntegrationStatus.SKIPPED_STATUS,
				SWED_BANK_INTEGRATION_STATUS(SwedBankIntegrationStatus.SKIPPED_STATUS),
			],
			[
				SwedBankIntegrationStatus.TO_BE_MANUALLY_PROCESSED_STATUS,
				SWED_BANK_INTEGRATION_STATUS(SwedBankIntegrationStatus.TO_BE_MANUALLY_PROCESSED_STATUS),
			],
		],
		colors: [
			[SwedBankIntegrationStatus.PROCESSED_STATUS, 'success.light'],
			[SwedBankIntegrationStatus.SKIPPED_STATUS, 'info.light'],
			[SwedBankIntegrationStatus.TO_BE_MANUALLY_PROCESSED_STATUS, 'warning.light'],
		],
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		buttons: [
			{ name: TypeOfDialog.MARK_AS_PROCESSED },
			{ name: TypeOfDialog.NOT_AN_INVOICE_PAYMENT },
		],
		buttonFilter: (item: ISwedBankIntegrationItem) => {
			// switch (item.status) {
			// 	case SwedBankIntegrationStatus.PROCESSED_STATUS:
			// 		return [];
			// 	case SwedBankIntegrationStatus.SKIPPED:
			// 		return [TypeOfDialog.MARK_AS_PROCESSED];
			// 	case SwedBankIntegrationStatus.TO_BE_MANUALLY_PROCESSED_STATUS:
			// 		return [TypeOfDialog.MARK_AS_PROCESSED, TypeOfDialog.NOT_AN_INVOICE_PAYMENT];
			// 	default:
			// 		return [TypeOfDialog.MARK_AS_PROCESSED, TypeOfDialog.NOT_AN_INVOICE_PAYMENT];
			// }
			const buttons = [];
			if (item.status === SwedBankIntegrationStatus.PROCESSED_STATUS) {
				buttons.push({ name: TypeOfDialog.MARK_AS_PROCESSED });
			} else if (item.status === SwedBankIntegrationStatus.SKIPPED_STATUS) {
				buttons.push({ name: TypeOfDialog.MARK_AS_PROCESSED });
			} else if (item.status === SwedBankIntegrationStatus.TO_BE_MANUALLY_PROCESSED_STATUS) {
				buttons.push(
					{ name: TypeOfDialog.MARK_AS_PROCESSED },
					{ name: TypeOfDialog.NOT_AN_INVOICE_PAYMENT },
				);
			}
			if (
				item.status !== SwedBankIntegrationStatus.PROCESSED_STATUS &&
				item.iossReimbursementNumber !== null
			) {
				buttons.push({ name: TypeOfDialog.ATTACH_VAT_REIMBURSEMENT });
			}
			return buttons;
		},
		align: ETableStructureAlign.LEFT,
	},
];
